import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getCookie } from "../Helpers/Utils";
import Handler from "../Helpers/Components/Handler";
import TablePlaceHolder from "../Helpers/Components/TablePlaceHolder";
import PageChanger from "../Helpers/Components/Pagination";
import moment from "moment";
import Modal from "../Helpers/Components/Modal";
import { toast } from "react-toastify";
import Select from 'react-select'

const Request = () => {
    const { pageNo, status } = useParams()
    const [requestList, setRequestList] = useState([])
    const [next, setNext] = useState(false)
    const [loading, setLoading] = useState(false)
    const person = getCookie("person")
    const navigate = useNavigate()
    const [requestId, setRequestId] = useState("")
    const [modal, setModal] = useState(false)
    const [count, setCount] = useState(10)
    const [reason, setReason] = useState({ open: false })
    const getRequestList = async () => {
        setLoading(true)
        const response = await Handler({ url: `/customer/request/deletion/list/${pageNo - 1}?count=${count || 10}`, method: 'POST', data: { ...(status !== "all" ? { status } : {}) } })
        if (response.success) {
            setRequestList(response?.data?.current)
            setNext(response?.data?.next)
        } else {
            setRequestList([])
            setNext(false)
        }
        setLoading(false)
    }
    const removeProof = async (accepted) => {
        setLoading(true)
        const response = await Handler({ url: `/admin/request/check/${requestId}`, method: `POST`, data: { accepted } })
        if (response?.success) {
            toast.success(response.success)
            getRequestList()
            setModal(false)
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    const shortText = (text, limit = 30) => {
        if (!text) return "";
        return text.length > limit ? text.slice(0, limit) + "..." : text;
    };
    const setPageNo = (value) => {
        navigate(`/request/${status}/${value}`)
    }
    const reinitiate = async () => {
        if (!reason?.reason) return toast.error("Reason is required")
        setLoading(true)
        const response = await Handler({ url: `/customer/remove/proof/reinitiate/${reason?.requestId}`, data: { reason: reason?.reason }, method: 'PATCH' })
        if (!response.success) {
            toast.error(response.message)
        } else {
            toast.success(response.message)
            setReason({ open: false })
            getRequestList()
        }
        setLoading(false)
    }
    useEffect(() => {
        getRequestList()
    }, [pageNo, count])
    return (
        <React.Fragment>
            <h5 className="text-center text-theme fs-4">Request List</h5>
            <div className="layout-card mt-2">
                <div className="row justify-content-between align-items-center mb-3">
                    <div className="col-lg-8">
                        <ul className="nav nav-underline">
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${status === "all" ? "active-tabs" : ""}`} aria-current="page" href="/request/all/1">All</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${status === "requested" ? "active-tabs" : ""}`} aria-current="page" href="/request/requested/1">Requested</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${status === "accepted" ? "active-tabs" : ""}`} aria-current="page" href="/request/accepted/1">Accepted</a>
                            </li>
                            <li className="nav-item">
                                <a className={`nav-link link-tabs ${status === "rejected" ? "active-tabs" : ""}`} aria-current="page" href="/request/rejected/1">Rejected</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className='overflow list-table mt-3'>
                    <table className="table-bg table" borderless="true">
                        <thead>
                            <tr className="border-bottom" >
                                <th>Request ID</th>
                                <th>Customer Id</th>
                                <th>Created At</th>
                                <th>Created By</th>
                                <th>Field</th>
                                <th>Reason</th>
                                <th>Status</th>
                                <th className="text-center">Active</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!loading ?
                                (requestList && requestList?.length !== 0 ? requestList?.map((value, key) => {
                                    return (
                                        <tr key={key} className={`table-content-row ${value?.status === "rejected" ? "text-red" : ""}`}>
                                            <td>{value?.requestId || ""}</td>
                                            <td> <a href={`/customer/proof/${value?.customerId}?proof=${value?.field?.field}`}>{value?.customerId || ""}</a></td>
                                            <td>{value?.createdAt ? moment(value?.createdAt).format('DD/MM/YYYY') : ""}</td>
                                            <td className="text-capitalize">{value?.subadmin?.name || ""}</td>
                                            <td className="text-capitalize">{value?.field?.field || ""}</td>
                                            <td><span className="viewReason"> {value?.reason ? shortText(value.reason) : ""} <span className="reason-text">Reason: {value.reason || ""}</span></span> </td>
                                            <td className={`${value?.status === "accepted" ? "text-success" : ""} text-capitalize`}>{value?.status || ""}</td>
                                            {
                                                person === "admin"
                                                    ?
                                                    <td className="text-center">{value?.status === "requested" ? <button className="btn btn-sm btn-danger" onClick={() => { setRequestId(value.requestId); setModal(true) }}>Remove</button> : ""}</td>
                                                    :
                                                    <td className="text-center">{value?.status === "rejected" ? <button className="btn btn-sm btn-success" onClick={() => { setReason({ ...value, open: true }) }}>Re-Initiate</button> : ""}</td>
                                            }
                                        </tr>
                                    )
                                }) :
                                    <tr className='text-center' ><td colSpan={8}>No Data Found</td></tr>)
                                : <TablePlaceHolder count={8} />
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex align-items-center justify-content-end mt-3">
                    <span className="me-2 fw-medium"> Page Count:  </span>
                    <Select
                        className="inside-select"
                        isDisabled={loading}
                        onChange={(selectedoption) => {
                            setCount(Number(selectedoption?.value))
                            setPageNo(1)
                        }}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                "&:hover": {
                                    borderColor: "#f16436"
                                }
                            }),
                            option: (style, state) => ({
                                ...style,
                                backgroundColor: state.isSelected
                                    ? "#f16436"
                                    : (state.isFocused || state.isActive)
                                        ? "#f164361a"
                                        : "white",
                                color: state.isSelected ? "white" : "black"
                            })
                        }}
                        value={count ? { label: count, value: count } : { label: 10, value: 10 }}
                        options={[
                            { label: 10, value: 10 },
                            { label: 20, value: 20 },
                            { label: 30, value: 30 },
                            { label: 40, value: 40 },
                            { label: 50, value: 50 },
                        ]}
                        placeholder="PageNo"
                    />
                </div>
                <PageChanger previousValue={Number(pageNo) > 1} nextValue={next} current={Number(pageNo)} onPageChange={setPageNo} pageValue={`request/${status}`} />
            </div>
            <Modal header="Confirmation" onShow={modal} toggle={() => setModal(false)} overlayToggle={() => setModal(false)}>
                <p className="confirmation">Are you sure you want to delete the proof?</p>
                <div className="d-flex align-items-center justify-content-center gap-3">
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={() => removeProof(false)}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Reject"}</button>
                    <button disabled={loading} className="btn btn-sm btn-success" onClick={() => removeProof(true)}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Remove"}</button>
                </div>
            </Modal>
            <Modal header="Confirmation" onShow={reason.open} toggle={() => setReason({ open: false })} overlayToggle={() => setReason({ open: false })}>
                <p className="confirmation">Are you sure you want to re-initiate the deletion process?</p>
                <input autoComplete="off" value={reason?.reason || ""} placeholder="Reason" disabled={loading} className="form-control input-theme text-uppercase" type="text" onChange={(e) => setReason((prev) => ({ ...prev, reason: e.target.value }))} />
                <div className="d-flex align-items-center justify-content-center gap-2 mt-3">
                    <button disabled={loading} className="btn btn-sm btn-success" onClick={reinitiate}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Yes"}</button>
                    <button disabled={loading} className="btn btn-sm btn-danger" onClick={() => setReason({ open: false })}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "No"}</button>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Request;